import { render, staticRenderFns } from "./updateAccount.vue?vue&type=template&id=31f11ede&scoped=true&"
import script from "./updateAccount.vue?vue&type=script&lang=js&"
export * from "./updateAccount.vue?vue&type=script&lang=js&"
import style0 from "./updateAccount.vue?vue&type=style&index=0&id=31f11ede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f11ede",
  null
  
)

export default component.exports